<template>
    <div class="integration-container">
        <button
            class="box integration"
            @click="showModal = true"
        >
            <img :src="integration.image" :alt="integration.name">
        </button>
        <integration-modal
            v-if="showModal"
            :integration="integration"
            @close="showModal=false"
        />
    </div>
</template>

<script>
import IntegrationModal from './IntegrationModal';

export default {
    components: {
        IntegrationModal,
    },

    props: {
        integration: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        showModal: false,
    }),
};
</script>
